/**
 * Animation constants used across the application
 * Extracted from useSmoothInViewAnimation for better code organization
 */

export const SMOOTH_IN_VIEW_DURATION = 0.35;
export const SMOOTH_IN_VIEW_EASE = [0.4, 0, 0.2, 1] as const;
export const SMOOTH_IN_VIEW_STAGGER = 0.06;
